import { Options } from '@angular-slider/ngx-slider';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { RegexService } from '../../shared/form-validation/regex.service';
import { ApiService } from '../../shared/services/apiService.service';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { environment } from '../../../environments/environment';
import { json } from 'express';

@Component({
  selector: 'app-tataokfilter',
  templateUrl: './tataokfilter.component.html',
  styleUrls: ['./tataokfilter.component.scss']
})
export class TataokfilterComponent implements OnInit {
  sub: Subscription = new Subscription
  environment1 = environment.s3bucket.url;
  subLobfilterList: any;
  final_filter: any = [];
  filterName: any[] = []
  filterList: any = []
  tempFilterArray: any[];
  actual_lob_name: any = [];
  pl_name: any = [];
  lob_name: any = [];
  vehicle_acpplication: any = [];
  ModelName: any = [];
  ppl_name: any = [];
  gvwFilterSelected: any = [];
  fuelFilterSelected: any = [];
  acFilterSelected: any = [];
  loadBodyFilterSelected: any = [];
  cabinTypeFilterSelected: any = [];
  wheelsFilterSelected: any = [];
  bodyTypeFilterSelected: any = [];
  floorValue: number;
  ceilValue: number;
  onPageLoad = false;
  tempMaxValue: number
  searchTotal: any = 0;
  usageCount: number = 0;
  segmentCount: any = 0;
  mainVehicleCount: any = 0;
  modelCount: any = 0;
  tonnageCount: any = 0;
  fuelCount: any = 0;
  acCount: any = 0;
  bodyCount: any = 0;
  loadBodyCount: any = 0;
  cabinTypeCount: any = 0;
  wheelCount: any = 0;
  searchData: string;
  tataokfilterList: any = []
  models:number=0;
  state:number=0;
  cities:number=0;
  Statelist: any;
  totalStatelist: any[];

  constructor(private activatedRoute: ActivatedRoute ,private behaviourSub: BehaviourSubjectService,
    private apiService: ApiService, private toastrService: ToastrService, private regexService: RegexService,
    @Inject(PLATFORM_ID) private platformId: Object) { }
    // environment1 = environment.s3bucket.url;
  data: any = {
    "data": [
      {
        "key": "Models",
        "priority": "0",
        "isvisible": "1",
           "image":`${this.environment1}assets/images/truckicon.svg`
      },

      {
        "key": "State",
        "priority": "2",
        "isvisible": "1",
        "image":`${this.environment1}assets/images/map_icon.svg`
      },
      {
        "key": "Budget",
        "priority": "1",
        "isvisible": "1",
        "image":`${this.environment1}assets/images/currency_rupee.svg`
      }
    ]
  }

  minValue: number = 0;
  maxValue: number;
  citySelected: any;
  modelSelected: any;
  stateSelected: any;
  budgetSelected: any;
  ssoptions: Options = {
    floor: 0,
    ceil: 937546,
    enforceStep: false,
    enforceRange: false,
  };


CatId:any;
  ngOnInit(): void {
       this.activatedRoute.params.subscribe((params) => {
      const data = params['catId'];
      this.CatId=params['id']
    });
    var vanType = ""
    this.activatedRoute.paramMap.subscribe(params => {
      this.subLobfilterList = "data";
      vanType = params.get('lob_name');
      if (params.get('sub_lob')) {
        if (this.actual_lob_name.find(element => element != this.actual_lob_name.push(params.get('sub_lob')))) {
          this.actual_lob_name.push(params.get('sub_lob'));
        }
      }
      if (params.get('search')) {
        this.searchData = params.get('search');
      }
      if (this.onPageLoad == true) {
        this.lob_name = [];
        if (vanType === "trucks") {
          this.lob_name.push(environment.truckLobId)
        }
        if (vanType === "buses" || vanType === "buses-vans") {
          this.lob_name.push(environment.busLobId)
        }
        if (vanType === "scv-pickups") {
          this.lob_name.push(environment.SCVPickupsLobId)
        }
        this.updateFilterSelectedArrays();
      }
      this.onPageLoad = true;
    });
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        if (params?.vehicle_application) {
          if (this.vehicle_acpplication.find(element => element != params?.vehicle_application)) {
            this.vehicle_acpplication.push(params?.vehicle_application);
          }
        }
        if (params?.actual_lob_name) {

          if (this.actual_lob_name.find(element => element != params?.actual_lob_name)) {
            this.actual_lob_name.push(params?.actual_lob_name);
          }
        }
        if (params?.model) {
          if (this.ModelName.find(element => element != params?.model)) {
            this.ModelName.push(params?.model);
          }
        }

      }
      );

    if (this.activatedRoute.snapshot.params['ppl_name']) {
      this.ppl_name = [];
      this.ppl_name.push(this.activatedRoute.snapshot.params['ppl_name'])
    }
    if (vanType === "trucks") {
      this.lob_name.push(environment.truckLobId)
    }
    if (vanType === "buses" || vanType === "buses-vans") {
      this.lob_name.push(environment.busLobId)
    }
    if (vanType === "scv-pickups") {
      this.lob_name.push(environment.SCVPickupsLobId)
    }
    this.sub.add(this.behaviourSub.generatetataokfilter.subscribe(data =>{
      if (data) {
        if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          this.getstate()
          this.getDropDownValues()
        }, 0);
      }
      }
    }))
    this.sub.add(this.behaviourSub.tataokisClearfilter.subscribe(data =>{
      if (data) {
      this.getstate()
      this.getDropDownValues()
      }
    }))
    this.sub.add(this.behaviourSub.isMobileFilter.subscribe(data => {
      if (data == 'rowLimit') {
        if (isPlatformBrowser(this.platformId)) {
        this.searchTotal = localStorage.getItem('rowLimit');
        }
      }
    }))
    this.sub.add(this.behaviourSub.filterValue.subscribe(params => {
      if (params != true && params != false) {
        if (params != 'Header' && params != 'Explore') {
          if (params == 'Budget') {
            if (isPlatformBrowser(this.platformId)) {

            let filterValue: any = []
            filterValue = JSON.parse(localStorage.getItem("normalFilterValue"))

            if (filterValue?.length > 0) {
              let i = filterValue.findIndex(element => element.category == 'price_from')
              filterValue.splice(i, 1);
              let t = filterValue.findIndex(element => element.category == 'price_to')
              filterValue.splice(t, 1);
              localStorage.setItem("normalFilterValue", JSON.stringify(filterValue))
              this.minValue = 0
              if (filterValue?.length==0) {
                let maxPrice =localStorage.getItem("max_price")
                this.maxValue=+(maxPrice);
                this.minValue=0
              }
            } else {

            }
          }
          }
          else {
            for (let j = 0; j < this.filterName?.length; j++) {

              if (this.filterName[j].data) {
                for (let i = 0; i < this.filterName[j].data?.length; i++) {
                  if (this.filterName[j].data[i].key == params) {
                    this.filterName[j].data[i].checked = false;
                    let filterValue: any = []
                    if (isPlatformBrowser(this.platformId)) {

                    filterValue = JSON.parse(localStorage.getItem("normalFilterValue"))
                    }
                    if (filterValue?.length > 0) {
                      if (filterValue.find(element => element.event == params)) {
                        let i = filterValue.findIndex(element => element.event == params)
                        this.generateFilterArray(filterValue[i].category, params, 'params');
                        filterValue.splice(i, 1)
                        if (isPlatformBrowser(this.platformId)) {

                        localStorage.setItem("normalFilterValue", JSON.stringify(filterValue))
                        }
                      } else {

                      }
                    } else {

                    }
                  }
                }
              }
            }
          }
        }
        else if (params == 'Header') {
          if (isPlatformBrowser(this.platformId)) {

          localStorage.removeItem('normalFilterValue');
          }
        }
        else if (params == 'Explore') {
          this.cities=0;
          this.state=0;
          this.models=0;
          this.usageCount = 0;
          this.segmentCount = 0;
          this.mainVehicleCount = 0;
          this.modelCount = 0;
          this.tonnageCount = 0;
          this.fuelCount = 0;
          this.acCount = 0;
          this.bodyCount = 0;
          this.loadBodyCount = 0;
          this.cabinTypeCount = 0;
          this.wheelCount = 0;
          this.clearAllFilter('Explore');
        }
      }
      else {
        let filterValue: any = []
        if (isPlatformBrowser(this.platformId)) {

        filterValue = JSON.parse(localStorage.getItem("normalFilterValue"))
        }
        if (filterValue?.length > 0) {
          let i = filterValue.findIndex(element => element.category == 'price_from')
          this.minValue = filterValue[i]?.event
          let t = filterValue.findIndex(element => element.category == 'price_to')
          this.tempMaxValue = filterValue[t]?.event
        }
      }
    }))

    if (this.subLobfilterList) {
      for (const values in this.data) {
        if (values == this.subLobfilterList) {
          this.filterName = (this.data[values]).sort((a: any, b: any) => a.priority - b.priority);
        }
      }
    }

    setTimeout(() => {
      this.sub.add(this.behaviourSub.budgetFiltertataok.subscribe((res: any) => {
        let maxPrice =localStorage.getItem("max_price")
         this.maxValue = res?.maxValue ? +(maxPrice) : this.tempMaxValue
         const newOptions: Options = Object.assign({}, this.ssoptions);
         newOptions.ceil = this.maxValue;
         this.ssoptions = newOptions;
       }));

     }, 500);
    this.updateFilterSelectedArrays()

  }

  updateFilterSelectedArrays() {
    let filterValue: any = []
    if (isPlatformBrowser(this.platformId)) {
    filterValue = JSON.parse(localStorage.getItem("normalFilterValue"))
    }
    if (filterValue?.length > 0) {
      for (let i = 0; i < filterValue?.length; i++) {
        this.generateFilterArray(filterValue[i].category, filterValue[i].event)
      }
      if (this.activatedRoute.snapshot.params['sub_lob']) {

        this.actual_lob_name.push(this.activatedRoute.snapshot.params['sub_lob'])
      }
      this.ppl_name = []
      if (this.activatedRoute.snapshot.params['ppl_name']) {

        this.ppl_name.push(this.activatedRoute.snapshot.params['ppl_name']);
      }
    }
    else {
      this.vehicle_acpplication = [];
      this.actual_lob_name = [];
      this.ModelName = [];
      this.ppl_name = [];
      this.gvwFilterSelected = [];
      this.fuelFilterSelected = [];
      this.acFilterSelected = [];
      this.loadBodyFilterSelected = [];
      this.cabinTypeFilterSelected = [];
      this.wheelsFilterSelected = [];
      this.bodyTypeFilterSelected = [];
      if (this.activatedRoute.snapshot.params['sub_lob']) {
        this.actual_lob_name.push(this.activatedRoute.snapshot.params['sub_lob']);
      }
      if (this.activatedRoute.snapshot.params['ppl_name']) {
        this.ppl_name.push(this.activatedRoute.snapshot.params['ppl_name']);
      }
    }
    this.getstate()
    this.getDropDownValues();
  }

  onCheckedClick(event: any, cateogry: any) {

    if (cateogry === 'State') {
      if (localStorage.getItem("normalFilterValue")) {

        const alreadyTrue = this.filterName[2].data.some(item => item.event === event && item.checked === true);


          if (alreadyTrue) {
            this.filterName[2].data=this.filterName[2].data.map((item) => {
              return { ...item, checked: false };
            });

            let normalFilterValue = JSON.parse(localStorage.getItem("normalFilterValue") || "[]");
            normalFilterValue = normalFilterValue.filter(item => item.category !== "State");
            localStorage.setItem("normalFilterValue", JSON.stringify(normalFilterValue));
          } else {


            let normalFilterValue = JSON.parse(localStorage.getItem("normalFilterValue"));
                let previous = normalFilterValue.filter(item => item.category !== 'State');
                normalFilterValue = normalFilterValue.filter(item => item.event == event);
                let merged = [...previous, ...normalFilterValue];
                localStorage.setItem("normalFilterValue", JSON.stringify(merged));

          }



      }
    }
    //previous
    // if (cateogry === 'State') {
    //   if (localStorage.getItem("normalFilterValue")) {
    //     let normalFilterValue = JSON.parse(localStorage.getItem("normalFilterValue"));

    //     normalFilterValue = normalFilterValue.filter(item => item.category !== "State" && item.category !== "District");

    //     localStorage.setItem("normalFilterValue", JSON.stringify(normalFilterValue));
    //   }
    // }

    for (let j = 0; j < this.filterName?.length; j++) {
      if (this.filterName[j].data) {
        for (let i = 0; i < this.filterName[j].data?.length; i++) {
          if (this.filterName[j].data[i].key == event) {
            this.filterName[j].data[i].checked = true
            this.filterName[j].data[i].category = cateogry
          }
        }
      }
    }
    if (isPlatformBrowser(this.platformId)) {

    this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
    if (this.filterList?.length > 0) {

      if (this.filterList.find(element => element.event == event)) {
        let i = this.filterList.findIndex(element => element.event == event)
        this.filterList.splice(i, 1);
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
      } else {
        this.filterList.push({ event: event, category: cateogry })
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
      }
    } else {
      if (this.filterList == null) {
        this.filterList = [];
      }
      this.filterList.push({ event: event, category: cateogry })
      localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
    }
  }
  this.cities=this.filterList.filter((obj) => obj === 'cities')?.length;
  this.state=this.filterList.filter((obj) => obj === 'state_list')?.length;
  this.models=this.filterList.filter((obj) => obj === 'models')?.length;

    this.behaviourSub.filterValue.next('Checkbox')

    this.generateFilterArray(cateogry, event);
    this.getstate()
    this.getDropDownValues();

  }

  generateFilterArray(cateogry, event, flag?) {
    this.modelSelected = this.modelSelected == undefined ? [] : this.modelSelected;
    this.citySelected = this.citySelected == undefined ? [] : this.citySelected;
    this.ModelName = this.ModelName == undefined ? [] : this.ModelName;
    this.stateSelected = this.stateSelected == undefined ? [] : this.stateSelected;
    this.gvwFilterSelected = this.gvwFilterSelected == undefined ? [] : this.gvwFilterSelected;
    this.fuelFilterSelected = this.fuelFilterSelected == undefined ? [] : this.fuelFilterSelected;
    this.acFilterSelected = this.acFilterSelected == undefined ? [] : this.acFilterSelected;
    this.loadBodyFilterSelected = this.loadBodyFilterSelected == undefined ? [] : this.loadBodyFilterSelected;
    this.cabinTypeFilterSelected = this.cabinTypeFilterSelected == undefined ? [] : this.cabinTypeFilterSelected;
    this.wheelsFilterSelected = this.wheelsFilterSelected == undefined ? [] : this.wheelsFilterSelected;
    this.bodyTypeFilterSelected = this.bodyTypeFilterSelected == undefined ? [] : this.bodyTypeFilterSelected;
    let data: any = {};
    if (cateogry == 'Models') {
      data['models'] = event;
      if (this.modelSelected.find(element => element == data.models)) {
        let i = this.modelSelected.findIndex(element => element == data.models)
        this.modelSelected.splice(i, 1);
      } else {
        this.modelSelected.push(data.models)
      }
    }
    if (cateogry == 'District') {
      data['cities'] = event;
      if (this.citySelected.find(element => element == data.cities)) {
        let i = this.citySelected.findIndex(element => element == data.cities)
        this.citySelected.splice(i, 1);
      } else {
        this.citySelected.push(data.cities)
      }
    }
    if (cateogry == 'State') {
      data['state_list'] = event;
      if (this.stateSelected.find(element => element == data.state_list)) {
        let i = this.stateSelected.findIndex(element => element == data.state_list)
        this.stateSelected.splice(i, 1);
      } else {
        this.stateSelected.push(data.state_list)
      }
    }


    if (cateogry == 'Cabin Type') {
      data['price'] = event;
    }

    if (flag == 'params') {
      this.getstate()
      this.getDropDownValues()
    }

  }

  getDropDownValues() {
    let data = {
      "lob_name": this.lob_name,
      "actual_lob_name": this.actual_lob_name,
      "pl_name": this.pl_name,
      "vehicle_application": this.vehicle_acpplication,
      "model": this.ModelName,
      "ppl_name": this.ppl_name,
      "gvw": this.gvwFilterSelected,
      "fuel_type": this.fuelFilterSelected,
      "air_conditioning": this.acFilterSelected,
      "load_body_length": this.loadBodyFilterSelected,
      "cabin_type": this.cabinTypeFilterSelected,
      "wheels": this.wheelsFilterSelected,
      "search": this.searchData ? this.searchData : ''
    }
    let Payload = {
      cat_id : Number(this.CatId)
    }
    this.sub.add(this.apiService.getTataokhomedatadistinct(Payload).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.totalStatelist=response?.data.state_list;
          this.Statelist = response?.data.state_list;
          this.final_filter = response.data
          var result = Object.entries(this.final_filter);
          for (let j = 0; j < this.filterName?.length; j++) {
            if (this.filterName[j].key == 'State') {
              let formatData: any = [];
              this.Statelist.forEach((state: string) => {
                formatData.push({ key: state, checked: false });

              });

              this.filterName[j]['data'] = formatData;
            }
          }
          for (let i = 0; i < result?.length; i++) {
            for (let j = 0; j < this.filterName?.length; j++) {
              if (this.filterName[j].key == 'Models' && result[i][0] == 'models') {
                let data: any = result[i][1]
                let formatData: any = []
                data.forEach((e: any) => {
                  formatData.push({ key: e, checked: false })
                })
                this.filterName[j]['data'] = formatData
              }
            }
          }
          for (let i = 0; i < result?.length; i++) {
            for (let j = 0; j < this.filterName?.length; j++) {
              if (this.filterName[j].key == 'Budget' && result[i][0] == 'msrp_min_max') {
                let data: any = result[i][1];
                let formatData: any = [];

                if (data.min_msrp != null && data.min_msrp !== '') {
                  formatData.push({ key: data.min_msrp, checked: false });
                }
                if (data.max_msrp != null && data.max_msrp !== '') {
                  formatData.push({ key: data.max_msrp, checked: false });
                }

                this.filterName[j]['data'] = formatData;

              }
            }
          }

          let filterValue: any = []
          if (isPlatformBrowser(this.platformId)) {
          filterValue = JSON.parse(localStorage.getItem("normalFilterValue"))
          if (filterValue?.length > 0) {
            setTimeout(() => {
            for (let i = 0; i < filterValue?.length; i++) {
              for (let j = 0; j < this.filterName?.length; j++) {
                if (filterValue[i].category == this.filterName[j].key) {
                  for (let k = 0; k < this.filterName[j].data?.length; k++) {
                    if (this.filterName[j].data[k].key == filterValue[i].event) {
                      this.filterName[j].data[k].checked = true;
                    }
                  }
                }
              }
            }
          }, 100);
          }
          this.tempFilterArray = this.filterName
          localStorage.setItem('tempFilterArray', JSON.stringify(this.tempFilterArray))
          localStorage.setItem('max_price', this.final_filter?.msrp_min_max?.max_msrp)
          let maxPrice =localStorage.getItem("max_price")
          this.maxValue=+(maxPrice);
          this.minValue=0
        }
        else {
          if (response.data.msg) {
            this.toastrService.warning(response.data.msg)
          }
        }
      }
      },
      error: () => { },
      complete: () => { }
    }))
  }

  clearAllFilter(flag) {
    if (flag == 'Mobile') {
      this.cities=0;
      this.state=0;
      this.models=0;
      this.usageCount = 0;
      this.segmentCount = 0;
      this.mainVehicleCount = 0;
      this.modelCount = 0;
      this.tonnageCount = 0;
      this.fuelCount = 0;
      this.acCount = 0;
      this.bodyCount = 0;
      this.loadBodyCount = 0;
      this.cabinTypeCount = 0;
      this.wheelCount = 0;
    }
    let filterValue: any = []
    this.vehicle_acpplication = [];
    this.actual_lob_name = [];
    this.ModelName = [];
    this.ppl_name = [];
    this.gvwFilterSelected = [];
    this.fuelFilterSelected = [];
    this.acFilterSelected = [];
    this.loadBodyFilterSelected = [];
    this.cabinTypeFilterSelected = [];
    this.wheelsFilterSelected = [];
    this.bodyTypeFilterSelected = [];
    this.citySelected=[];
    this.modelSelected=[];
    this.stateSelected=[];
    this.minValue = 0;
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.sub.add(this.behaviourSub.budgetFiltertataok.subscribe((res: any) => {
          // this.minValue=res?.minValue ? res?.minValue:0
          let maxPrice =localStorage.getItem("max_price")
           this.maxValue = res?.maxValue ? +(maxPrice) : this.tempMaxValue
           const newOptions: Options = Object.assign({}, this.ssoptions);
           newOptions.ceil = this.maxValue;
           this.ssoptions = newOptions;
         }));

       }, 500);
    this.filterName = this.filterName.filter(item => item.key !== 'District');
    filterValue = JSON.parse(localStorage.getItem("normalFilterValue"))
    if (filterValue?.length > 0) {
      for (let i = 0; i < filterValue?.length; i++) {
        for (let j = 0; j < this.filterName?.length; j++) {
          if (filterValue[i].category == this.filterName[j].key) {
            if (this.filterName[j].data) {

              for (let k = 0; k < this.filterName[j].data?.length; k++) {
                if (this.filterName[j].data[k].key == filterValue[i].event) {
                  this.filterName[j].data[k].checked = false;
                }
              }
            }
          }
        }
      }
      localStorage.removeItem("normalFilterValue");
      this.updateFilterSelectedArrays();
      if (flag != 'Explore') {
        this.behaviourSub.filterValue.next('Clear')
      }
    }
  }
  }

  searchFilter(rowData, value) {

    var temp = [];
    var index = this.filterName.findIndex((item: any) => item.key == rowData.key)
    this.tempFilterArray = JSON.parse(localStorage.getItem('tempFilterArray'));
    temp = this.tempFilterArray[index].data.filter(obj => (obj.key?.toLowerCase()).includes(value?.toLowerCase()))
    this.filterName[index].data = temp;

  }

  removeFromArray(data) {
    if (this.modelSelected.find(element => element == data)) {
      let i = this.modelSelected.findIndex(element => element == data)
      this.modelSelected.splice(i, 1);
    }
    if (this.citySelected.find(element => element == data)) {
      let i = this.citySelected.findIndex(element => element == data)
      this.citySelected.splice(i, 1);
    }
    if (this.ModelName.find(element => element == data)) {
      let i = this.ModelName.findIndex(element => element == data)
      this.ModelName.splice(i, 1);
    }
    if (this.stateSelected.find(element => element == data)) {
      let i = this.stateSelected.findIndex(element => element == data)
      this.stateSelected.splice(i, 1);
    }
    if (this.gvwFilterSelected.find(element => element == data)) {
      let i = this.gvwFilterSelected.findIndex(element => element == data)
      this.gvwFilterSelected.splice(i, 1);
    }
    if (this.fuelFilterSelected.find(element => element == data)) {
      let i = this.fuelFilterSelected.findIndex(element => element == data)
      this.fuelFilterSelected.splice(i, 1);
    }
    if (this.acFilterSelected.find(element => element == data)) {
      let i = this.acFilterSelected.findIndex(element => element == data)
      this.acFilterSelected.splice(i, 1);
    }
    if (this.loadBodyFilterSelected.find(element => element == data)) {
      let i = this.loadBodyFilterSelected.findIndex(element => element == data)
      this.loadBodyFilterSelected.splice(i, 1);
    }
    if (this.cabinTypeFilterSelected.find(element => element == data)) {
      let i = this.cabinTypeFilterSelected.findIndex(element => element == data)
      this.cabinTypeFilterSelected.splice(i, 1);
    }
    if (this.wheelsFilterSelected.find(element => element == data)) {
      let i = this.wheelsFilterSelected.findIndex(element => element == data)
      this.wheelsFilterSelected.splice(i, 1);
    }
    if (this.bodyTypeFilterSelected.find(element => element == data)) {
      let i = this.bodyTypeFilterSelected.findIndex(element => element == data)
      this.bodyTypeFilterSelected.splice(i, 1);
    }

  }
  onbudegetChange(event: any, cateogry: any) {
    let filterValue: any = []
    filterValue = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
    if (filterValue?.length > 0) {
      if (cateogry == 'price_from') {
        this.minValue = event.target.value
        let i = filterValue.findIndex(element => element.category == 'price_from')
        filterValue.splice(i, 1);
        let t = filterValue.findIndex(element => element.category == 'price_to')
        filterValue.splice(t, 1);
        localStorage.setItem("normalFilterValue", JSON.stringify(filterValue))
        this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
        this.ssoptions.floor = 0
        this.minValue = this.minValue
        this.filterList.push({ event: this.minValue, category: cateogry })
        this.filterList.push({ event: this.maxValue, category: 'price_to' })
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
      }
      if (cateogry == 'price_to') {
        this.maxValue = event.target.value
        let i = filterValue.findIndex(element => element.category == 'price_from')
        filterValue.splice(i, 1);
        let t = filterValue.findIndex(element => element.category == 'price_to')
        filterValue.splice(t, 1);
        localStorage.setItem("normalFilterValue", JSON.stringify(filterValue))
        this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
        this.filterList.push({ event: this.minValue, category: 'price_from' })
        this.filterList.push({ event: this.maxValue, category: cateogry })
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
      }
    }
    else {
      if (cateogry == 'price_from') {
        let i = this.filterList.findIndex(element => element.category == 'price_from')
        this.filterList.splice(i, 1);
        let t = this.filterList.findIndex(element => element.category == 'price_to')
        this.filterList.splice(t, 1);
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
        this.ssoptions.floor = 0
        this.minValue = event.target.value
        this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
        this.filterList.push({ event: this.minValue, category: cateogry })
        this.filterList.push({ event: this.maxValue, category: 'price_to' })
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
      }
      if (cateogry == 'price_to') {
        let i = this.filterList.findIndex(element => element.category == 'price_from')
        this.filterList.splice(i, 1);
        let t = this.filterList.findIndex(element => element.category == 'price_to')
        this.filterList.splice(t, 1);
        this.maxValue = event.target.value
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
        this.filterList.push({ event: this.minValue, category: 'price_from' })
        this.filterList.push({ event: this.maxValue, category: cateogry })
        localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
      }
    }
    let data: any = {};
    if (cateogry == 'price_from') {
      data['price_from'] = event.target.value;
    }
    if (cateogry == 'price_to') {
      data['price_to'] = event.target.value;
    }
    this.behaviourSub.filterValue.next(null)
  }

  sliderEvent() {
     let filters = JSON.parse(localStorage.getItem('tataOkFilters') || '{}');
      if (filters) {
        delete filters.minprice;
        delete filters.maxprice;
      }
      localStorage.setItem('tataOkFilters', JSON.stringify(filters));
    let filterValue: any = []
    filterValue = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
    if (filterValue?.length > 0) {
      let i = filterValue.findIndex(element => element.category == 'price_from')
      filterValue.splice(i, 1);
      let t = filterValue.findIndex(element => element.category == 'price_to')
      filterValue.splice(t, 1);
      localStorage.setItem("normalFilterValue", JSON.stringify(filterValue))
      this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
      this.filterList.push({ event: this.minValue, category: 'price_from' })
      this.filterList.push({ event: this.maxValue, category: 'price_to' })
      localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
    }
    else {
     this.filterList = localStorage.getItem("normalFilterValue") ? JSON.parse(localStorage.getItem("normalFilterValue")) : []
      this.filterList.push({ event: this.minValue, category: 'price_from' })
      this.filterList.push({ event: this.maxValue, category: 'price_to' })
      localStorage.setItem("normalFilterValue", JSON.stringify(this.filterList))
    }

    this.behaviourSub.filterValue.next(null)
  }

  updateSliderRange() {
    this.floorValue = 50;
    this.ceilValue = 200;
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }

  closeFilter() {
    this.behaviourSub.isMobileFilter.next('Close');
  }
  getDistinctdata() {
    try {
      this.sub.add(this.apiService.getTataokhomedatadistinct('').subscribe((res: any) => {
        this.tataokfilterList=res.data;
      })
      )
    } catch (error) {
    }
  }
  getstate(): void {
    let Payload = {
      cat_id : Number(this.CatId)
    }
    this.sub.add(
      this.apiService.getTataokhomedatadistinct(Payload).subscribe({
        next: (result: any) => {
         this.totalStatelist=result?.data.state_list;
          this.Statelist = result?.data.state_list;
          this.models=result?.data?.models
          this.getDistricts();
        },
        error: (err: any) => {

        },
        complete: () => {

        }
      })
    );
  }
  getDistricts(): void {
    let states = JSON.parse(localStorage.getItem("normalFilterValue"));
    if (states) {
    const stateEvents = states.filter(item => item.category === "State");
  if (stateEvents?.length>0) {
    if (!this.filterName.some(item => item.key === "District")) {
    this.filterName.push({
      key: "District",
      priority: "3",
      isvisible: "1",
      image:`${this.environment1}assets/images/location_icon.svg`
    });
  }
    stateEvents.forEach(stateEvent => {
      let currentState = this.totalStatelist.find(element => element === stateEvent.event);
      if (currentState) {
        // let json: any = { "state": { "code": currentState.code, "state": currentState.name } };
        let json: any =   {
          "cat_id":this.CatId,
          "state":[currentState]
      }
        this.sub.add(
          this.apiService.getTataokhomedatadistinct(json).subscribe({
            next: (result: any) => {
              if (result?.data?.district_list?.length > 0) {
              for (let j = 0; j < this.filterName?.length; j++) {
                if (this.filterName[j].key === 'District') {
                  let formatData: any = [];
                  result?.data?.district_list.forEach((city: string) => {
                    formatData.push({ key: city, checked: false });
                  });
                  this.filterName[j]['data'] = formatData;
                }
              }
              this.tempFilterArray = this.filterName
          localStorage.setItem('tempFilterArray', JSON.stringify(this.tempFilterArray))
        }
            },
            error: (err: any) => {
            },
            complete: () => {
            }
          })
        );
      }
    });
  }
  else
  {
    this.filterName = this.filterName.filter(item => item.key !== 'District');
    let filteritems=JSON.parse(localStorage.getItem("normalFilterValue"));
    filteritems=filteritems.filter(item => item.category !== 'District')
    localStorage.setItem("normalFilterValue", JSON.stringify(filteritems))
  }
}
else
{

}
}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }


}
